import React from "react";
var __jsx = React.createElement;
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "@i18n";
import stl from "./TfaseelAndRportHeader.module.css";
var TfaseelAndRportHeader = function TfaseelAndRportHeader(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var el = useRef();
  var _useState = useState(false),
    IsFixed = _useState[0],
    setIsFixed = _useState[1];
  useEffect(function () {
    var handleScroll = function handleScroll(event) {
      if (document.querySelector(".myHeadingToggler") != null) {
        if (document.querySelector(".myHeadingToggler").getBoundingClientRect().top <= 0) {
          document.getElementById("desktopHeader").style.opacity = 0;
        } else {
          document.getElementById("desktopHeader").style.opacity = 1;
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return function () {
      // window.removeEventListener("popstate", NoBack);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    ref: el,
    className: ["myHeadingToggler", stl.postHalfHeader, IsFixed ? stl.fixMe : undefined].join(" "),
    id: "post-tabs-header"
  }, /*#__PURE__*/React.createElement("span", {
    id: "tab-car-info",
    className: props.activeReport == 0 ? stl.activeTab : undefined,
    onClick: function onClick() {
      return props.setActive && props.setActive(0);
    }
  }, t("car_information", {
    ns: "web_post_view"
  })), props.isInspectionAvailable && /*#__PURE__*/React.createElement("span", {
    id: "tab-inspection-report",
    className: props.activeReport == 1 ? stl.activeTab : undefined,
    onClick: function onClick() {
      return props.setActive && props.setActive(1);
    }
  }, t("inspection_report", {
    ns: "web_post_view"
  }))));
};
export default TfaseelAndRportHeader;